import { render, staticRenderFns } from "./k-sub-bread.vue?vue&type=template&id=4f3ec8bb&scoped=true&"
import script from "./k-sub-bread.vue?vue&type=script&lang=js&"
export * from "./k-sub-bread.vue?vue&type=script&lang=js&"
import style0 from "./k-sub-bread.vue?vue&type=style&index=0&id=4f3ec8bb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3ec8bb",
  null
  
)

export default component.exports